export default __webpack_public_path__ + "static/media/pro_aim_mikel.976e6fa9.png";